import { render, staticRenderFns } from "./ModalBreakfasts.vue?vue&type=template&id=254de3a4&"
import script from "./ModalBreakfasts.vue?vue&type=script&lang=js&"
export * from "./ModalBreakfasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports